/* eslint-disable */
import { FuseNavigationItem } from "app/shared/@fuse/components/navigation";

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'supplier',
        title: 'Fornitori',
        type: 'basic',
        icon: 'heroicons_outline:identification',
        link: '/fornitori'
    },
    {
        id: 'contract',
        title: 'Contratti',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/contracts'
    },
    {
        id: 'outsourcingRegistry',
        title: 'Registro Outsourcing',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-check',
        link: '/outsourcing-register'
    },
    {
        id: 'outsourcingNotification',
        title: 'Avvio Segnalazione',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/report'
    },
    {
        id: 'analytics',
        title: 'Analytics',
        type: 'collapsable', // Cambiato in "collapsable" per avere un sottomenu
        icon: 'heroicons_outline:chart-pie',
        children: [
            {
                id: 'report',
                title: 'Dashboard Segnalazione',
                type: 'basic',
                link: '/analytics/reports'
            },
            {
                id: 'evaluation-sheets',
                title: 'Dashboard Schede Valutazione',
                type: 'basic',
                link: '/analytics/evaluation-sheets'
            },
            {
                id: 'contracts-and-suppliers',
                title: 'Dashboard Contratti e Fornitori',
                type: 'basic',
                link: '/analytics/contracts-and-suppliers'
            }            
        ]
    },
    {
        id: 'auditing',
        title: 'Auditing',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/auditing'
    },
    {
        id: 'logout',
        title: 'Esci',
        type: 'basic',
        icon: 'heroicons_outline:arrow-right-on-rectangle',
        meta: {
            action: 'logout'
        }
    }
];


export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'supplier',
        title: 'Fornitori',
        type: 'basic',
        icon: 'heroicons_outline:identification',
        link: '/fornitori'
    },
    {
        id: 'contract',
        title: 'Contratti',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/contracts'
    },
    {
        id: 'outsourcingRegistry',
        title: 'Registro Outsourcing',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-check',
        link: '/outsourcing-register'
    },
    {
        id: 'outsourcingNotification',
        title: 'Avvio Segnalazione',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/report'
    },
    {
        id: 'analytics',
        title: 'Analytics',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: "/analytics"
    },
    {
        id: 'auditing',
        title: 'Auditing',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/auditing'
    },
    {
        id: 'logout',
        title: 'Esci',
        type: 'basic',
        icon: 'heroicons_outline:arrow-right-on-rectangle',
        meta: {
            action: 'logout'
        }
    }
];

export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'supplier',
        title: 'Fornitori',
        type: 'basic',
        icon: 'heroicons_outline:identification',
        link: '/fornitori'
    },
    {
        id: 'contract',
        title: 'Contratti',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/contracts'
    },
    {
        id: 'outsourcingRegistry',
        title: 'Registro Outsourcing',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-check',
        link: '/outsourcing-register'
    },
    {
        id: 'outsourcingNotification',
        title: 'Avvio Segnalazione',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/report'
    },
    {
        id: 'analytics',
        title: 'Analytics',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: "/analytics"
    },
    {
        id: 'auditing',
        title: 'Auditing',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/auditing'
    },
    {
        id: 'logout',
        title: 'Esci',
        type: 'basic',
        icon: 'heroicons_outline:arrow-right-on-rectangle',
        meta: {
            action: 'logout'
        }
    }
];

export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'supplier',
        title: 'Fornitori',
        type: 'basic',
        icon: 'heroicons_outline:identification',
        link: '/fornitori'
    },
    {
        id: 'contract',
        title: 'Contratti',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/contracts'
    },
    {
        id: 'outsourcingRegistry',
        title: 'Registro Outsourcing',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-check',
        link: '/outsourcing-register'
    },
    {
        id: 'outsourcingNotification',
        title: 'Avvio Segnalazione',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/report'
    },
    {
        id: 'analytics',
        title: 'Analytics',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: "/analytics"
    },
    {
        id: 'auditing',
        title: 'Auditing',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/auditing'
    },
    {
        id: 'logout',
        title: 'Esci',
        type: 'basic',
        icon: 'heroicons_outline:arrow-right-on-rectangle',
        meta: {
            action: 'logout'
        }
    }
];